export const BookmarkOutlinedIcon = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path stroke="#222222" strokeLinecap="round" strokeLinejoin="round" d="M13.75 3.125H6.25C5.55964 3.125 5 3.68464 5 4.375V16.6532C5 16.8922 5.25739 17.0427 5.46571 16.9255L9.84679 14.4612C9.94192 14.4077 10.0581 14.4077 10.1532 14.4612L14.5343 16.9255C14.7426 17.0427 15 16.8922 15 16.6532V4.375C15 3.68464 14.4404 3.125 13.75 3.125Z" />
  </svg>

);
